export const CHILD_SUPPORT_CAL = "CHILD_SUPPORT_CAL";
export const SPOUSAL_SUPPORT_CAL = "SPOUSAL_SUPPORT";
export const CHILD_AND_SPOUSAL_SUPPORT_CAL = "CHILD_AND_SPOUSAL_SUPPORT";